/// <amd-module name="VSSUI/Components/Panel/PanelFooter" />
import * as React from "react";

import { Button } from "VSSUI/Button";
import { ButtonGroup } from "VSSUI/ButtonGroup";
import { SurfaceContext } from "VSSUI/Surface";
import { css } from "VSSUI/Util";

import { IPanelFooterProps } from "VSSUI/Components/Panel/Panel.Props";

export const PanelFooter: React.SFC<IPanelFooterProps> = props => {
    const { buttonProps, className, showSeparator } = props;
    let footerContent: React.ReactNode | null = null;
    if (buttonProps) {
        footerContent = (
            <ButtonGroup className="bolt-panel-footer-buttons flex-grow">
                {buttonProps.map((buttonProps, index) => (
                    <Button key={buttonProps.id || index} {...buttonProps} />
                ))}
            </ButtonGroup>
        );
    } else {
        footerContent = props.children;
    }
    return (
        <SurfaceContext.Consumer>
            {surfaceContext => (
                <>
                    {showSeparator && <div className="bolt-panel-separator flex-noshrink" />}
                    <div className={css(className, "bolt-panel-footer flex-center", surfaceContext.horizontalClassName)}>{footerContent}</div>
                </>
            )}
        </SurfaceContext.Consumer>
    );
};
